module.exports = __webpack_public_path__ + "images/bannerIT-a233f7507e3bb59a09a684f4bb9fda2d.png";